module.exports = __webpack_public_path__ + "assets/img/effect_(5).d9fb55bb.gif";